import type { WillowProperty } from "@/web/routes/explore/-types";

export const CATSKILLS_PROPERTIES: WillowProperty[] = [
  {
    id: "1",
    address: {
      addressLine1: "418 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.220386,
    longitude: -73.865648,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.220314413667886%2C-73.86594146208228&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=73.3&signature=BCadVPfJX-O-R7kkIhmJeIMaG3Y=",
    tags: ["FOR_SALE"],
    sqft: 2568,
    tenant: null,
    timeOnMarketDays: 30,
    askingPrice: 595000,
    priorSale: {
      price: 395000,
      date: "2022-01-04",
    },
    withusValuation: {
      price: 448093,
    },
  },
  {
    id: "2",
    address: {
      addressLine1: "447 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.22123,
    longitude: -73.866687,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.221303245018035%2C-73.86633117965587&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=253.8&signature=mNakdBvH28DAEzT6_xcdGKYS0iI=",
    tags: ["FOR_SALE"],
    sqft: 12640,
    tenant: null,
    timeOnMarketDays: 30,
    askingPrice: 699000,
    priorSale: {
      price: 12500,
      date: "1991-10-30",
    },
    withusValuation: {
      price: 373000,
    },
  },
  {
    id: "3",
    address: {
      addressLine1: "460 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.22199,
    longitude: -73.866395,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.22194566795258%2C-73.86658858203114&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=73.7&signature=RqaCfb07chzUIvbj113w-RlFi78=",
    tags: ["FOR_SALE"],
    tenant: null,
  },
  {
    id: "4",
    address: {
      addressLine1: "462 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.222079,
    longitude: -73.866387,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.22203015625276%2C-73.86662301653853&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=71.8&signature=P9fdK2d6eLlO29crpVycjJDXiGE=",
    tags: ["FOR_SALE"],
    tenant: { name: "Flux Studio" },
  },
  {
    id: "5",
    address: {
      addressLine1: "65 W Bridge Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.216463,
    longitude: -73.871115,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.216625436326844%2C-73.87122045519003&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=167.5&signature=Z87qNsZIEqUonS5iEfr_bw6-eto=",
    tags: ["FOR_SALE"],
    sqft: 4100,
    tenant: { name: "Juice Branch" },
    timeOnMarketDays: 30,
    askingPrice: 549000,
    priorSale: {
      price: 160000,
      date: "2005-05-20",
    },
    withusValuation: {
      price: 396000,
    },
  },
  {
    id: "6",
    address: {
      addressLine1: "385 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.219201,
    longitude: -73.865712,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21923809785345%2C-73.86551923125245&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=254.9&signature=qwo60aa4pc6euzz-5Y6vXZUZobU=",
    tags: ["FOR_LEASE"],
    sqft: 4000,
    tenant: null,
    priorSale: {
      price: 400000,
      date: "2024-07-16",
    },
  },
  {
    id: "7",
    address: {
      addressLine1: "296-298 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.21635001856893,
    longitude: -73.86420791405052,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21628136016156%2C-73.86436683674398&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=63.1&signature=C3ZCJ36Vax1vVl2hLtKAqpiRH7Q=",
    tags: ["FOR_SALE"],
    sqft: 7896,
    tenant: { name: "Fawn's Leap Tattoo, 1st Main Deli" },
    timeOnMarketDays: 30,
    askingPrice: 1250000,
    priorSale: {
      price: 673000,
      date: "2020-01-24",
    },
  },
  {
    id: "8",
    address: {
      addressLine1: "416 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.220329,
    longitude: -73.86559,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.22025657196576%2C-73.86591807413866&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=73.3&signature=uH447B4uVkBTVzT6FHuHcek2NN0=",
    tags: ["FOR_SALE"],
    sqft: 3080,
    tenant: { name: "Village Pizza" },
    timeOnMarketDays: 360,
    askingPrice: 1175000,
    withusValuation: {
      price: 331500,
    },
  },
  {
    id: "9",
    address: {
      addressLine1: "414 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.220259,
    longitude: -73.865654,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.22020035382323%2C-73.86589534271448&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=73.3&signature=zWsyTljroxlb6ZFuvdwrKMrRLPk=",
    tags: ["FOR_SALE"],
    sqft: 2300,
    tenant: { name: "Catskill Cryo" },
    timeOnMarketDays: 390,
    askingPrice: 549000,
    priorSale: {
      price: 75000,
      date: "2015-10-05",
    },
    withusValuation: {
      price: 264500,
    },
  },
  {
    id: "10",
    address: {
      addressLine1: "175 W Bridge Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.215192,
    longitude: -73.877407,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.215500000000006%2C-73.877452&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=175.2&signature=FOy05fgx7KLZQdEojoYKzCwTeRI=",
    tags: ["FOR_LEASE"],
    sqft: 2362,
    tenant: null,
  },
  {
    id: "11",
    address: {
      addressLine1: "399 W Bridge Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.213586,
    longitude: -73.888811,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.213621050881%2C-73.88837719682303&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=267.3&signature=_1Ybu3Zsq77queSiXsiDm9uR3w4=",
    tags: ["OFF_MARKET"],
    sqft: 2564,
    tenant: null,
  },
  {
    id: "12",
    address: {
      addressLine1: "14 Boulevard Ave",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.21371,
    longitude: -73.881426,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21388794861983%2C-73.88120724061766&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=219.2&signature=o6UyecFda6CzOAJTWygxjBVwzN8=",
    tags: ["FOR_SALE"],
    sqft: 6750,
    tenant: { name: "Ace Hardware" },
    timeOnMarketDays: 150,
    askingPrice: 934013,
  },
  {
    id: "13",
    address: {
      addressLine1: "7 Main St",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.21037,
    longitude: -73.85433,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21046390000001%2C-73.854286&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=197.9&signature=zeTGIUnB4k3-qazAeVv_tLxxLqM=",
    tags: ["FOR_SALE", "FOR_LEASE"],
    sqft: 6504,
    tenant: { name: "Frank Guido's Port of Call" },
    timeOnMarketDays: 3060,
    askingPrice: 1395000,
  },
  {
    id: "14",
    address: {
      addressLine1: "1114 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.2553,
    longitude: -73.90092,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.25493350069677%2C-73.90102516678306&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=15.1&signature=3hOCVOGGlJdDGr0WAvcvdhdXXTc=",
    tags: ["FOR_SALE"],
    sqft: 6090,
    tenant: { name: "Residential Tenants" },
    askingPrice: 1750000,
  },
  {
    id: "15",
    address: {
      addressLine1: "746 NY-23B",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.228759,
    longitude: -73.861868,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.2487871%2C-73.8878932&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&signature=KKATN59aXOuS0daDdm3a4cYeHZk=",
    tags: ["FOR_SALE"],
    sqft: 11466,
    tenant: { name: "Anthony's Banquet Hall & Restaurant" },
    askingPrice: 1499000,
  },
  {
    id: "16",
    address: {
      addressLine1: "734 NY-32A",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12463",
      countryCode: "US",
    },
    latitude: 42.174575,
    longitude: -74.019465,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.17442096512021%2C-74.01968376098968&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=47.8&signature=-NUY5qN56fPMHXpBgv-7OgziKAE=",
    tags: ["FOR_SALE"],
    sqft: 1704,
    tenant: null,
    askingPrice: 649000,
  },
  {
    id: "17",
    address: {
      addressLine1: "5454 NY-32",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.244833,
    longitude: -73.978211,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.2447161582871%2C-73.97845811279794&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=106.5&signature=Q2N9ayDQpA08t75oXI08YL_sU3s=",
    tags: ["FOR_SALE"],
    sqft: 6000,
    tenant: null,
    timeOnMarketDays: 480,
    askingPrice: 275000,
  },
  {
    id: "18",
    address: {
      addressLine1: "2 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.21066,
    longitude: -73.85396,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.2107754%2C-73.8536783&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&signature=yfvxAZRcZwohg3O3PaGrl3CebDM=",
    tags: ["OFF_MARKET"],
    tenant: { name: "Historic Catskill Point and Freightmasters Building" },
  },
  {
    id: "19",
    address: {
      addressLine1: "27 Brooks Lane",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.240432,
    longitude: -73.883426,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.240412587592%2C-73.88328330504514&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=276.0&signature=zi3N_zJt3-NFAaatA3xrqfSPVjg=",
    tags: ["FOR_SALE"],
    sqft: 4000,
    tenant: { name: "Catskill Golf Resort" },
    askingPrice: 2750000,
  },
  {
    id: "20",
    address: {
      addressLine1: "62 Water St & 81 Water St",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.219406,
    longitude: -73.866645,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21638059759077%2C-73.86601718671533&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=74.4&signature=fCvU8JblWBoPx4OJt1xuD2UgpEU=",
    tags: ["FOR_SALE"],
    sqft: 33658,
    tenant: { name: "LUMBERYARD Center for Film and Performing Arts" },
    timeOnMarketDays: 900,
    askingPrice: 6350000,
  },
  {
    id: "21",
    address: {
      addressLine1: "11 Maple Ave",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.216063,
    longitude: -73.877646,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21581437641527%2C-73.87728266033483&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=309.1&signature=HEhPpX4_X98x_38ZKjbAmo0O01c=",
    tags: ["FOR_SALE"],
    sqft: 3515,
    tenant: { name: "WellNow Urgent Care" },
    timeOnMarketDays: 210,
    askingPrice: 2021126,
  },
  {
    id: "22",
    address: {
      addressLine1: "400 Game Farm Rd",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.235848,
    longitude: -74.007183,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.23548781661639%2C-74.00786159173678&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=356.3&signature=yvdGFEvVJh4rXxoiTmphBqPkgvE=",
    tags: ["FOR_SALE"],
    sqft: 15309,
    tenant: { name: "The Old Game Farm" },
    timeOnMarketDays: 30,
    askingPrice: 2995000,
  },
  {
    id: "23",
    address: {
      addressLine1: "279 Hamburg Road",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.23324,
    longitude: -73.84998,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.23310721123738%2C-73.84988644756821&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=311.4&signature=K2HhauPpCT7QOalmcUdns_t0-lw=",
    tags: ["FOR_SALE"],
    sqft: 3834,
    tenant: { name: "Residential Tenants" },
    askingPrice: 1250000,
  },
  {
    id: "24",
    address: {
      addressLine1: "4858 NY-32",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.207962,
    longitude: -73.980892,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.20762856464468%2C-73.98220729931965&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=70.9&signature=2WT_reLKXaIMTXF5fhx_5WuugfY=",
    tags: [],
    sqft: 450000,
    tenant: null,
    timeOnMarketDays: 1830,
    askingPrice: 7600000,
  },
  {
    id: "25",
    address: {
      addressLine1: "4880 NY-32",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.212364,
    longitude: -73.981169,
    tags: ["FOR_SALE"],
    tenant: null,
    askingPrice: 6500000,
  },
  {
    id: "26",
    address: {
      addressLine1: "111 Water St",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.218041,
    longitude: -73.866396,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21806148603117%2C-73.86618830352927&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=264.4&signature=ONu1rPL5_mSb2-O8jGq8G-UMpnk=",
    tags: ["FOR_LEASE"],
    sqft: 37590,
    tenant: { name: "Foreland Tenants (15+)" },
    timeOnMarketDays: 150,
  },
  {
    id: "27",
    address: {
      addressLine1: "605 Green Lake Road",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.292011,
    longitude: -73.882245,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.288995360521085%2C-73.88249849243438&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=352.9&signature=FNFIXop0JhGNJldJgGfEu9uzFpo=",
    tags: ["FOR_SALE"],
    tenant: null,
    askingPrice: 5995000,
  },
  {
    id: "28",
    address: {
      addressLine1: "125 Water St",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.21868,
    longitude: -73.8665,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.2187127352536%2C-73.86639792823075&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=253.7&signature=0vwkGnkyHtRsXq6xVte5T8NS0lQ=",
    tags: ["FOR_LEASE"],
    sqft: 10000,
    tenant: null,
    timeOnMarketDays: 180,
  },
  {
    id: "29",
    address: {
      addressLine1: "4952 NY-32",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.212635,
    longitude: -73.98488,
    tags: ["FOR_SALE"],
    sqft: 1710,
    tenant: { name: "Brookside Campground" },
    timeOnMarketDays: 180,
    askingPrice: 2500000,
  },
  {
    id: "30",
    address: {
      addressLine1: "104 Water Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.217885,
    longitude: -73.86601,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.217938499999995%2C-73.8661721&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=89.2&signature=D7K9cK51DDjKidjF2OSAx0c5ofc=",
    tags: ["OFF_MARKET"],
    sqft: 4428,
    tenant: null,
    priorSale: {
      price: 350000,
      date: "2024-10-11",
    },
    withusValuation: {
      price: 360000,
    },
  },
  {
    id: "31",
    address: {
      addressLine1: "321 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.217083,
    longitude: -73.865058,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.217203903368784%2C-73.8647235667816&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=241.9&signature=r7GidWyoMoQfu_3uDKqrVbnVxVY=",
    tags: ["OFF_MARKET"],
    sqft: 8006,
    tenant: { name: "Catskill Antique Market" },
    priorSale: {
      price: 890000,
      date: "2022-05-13",
    },
  },
  {
    id: "32",
    address: {
      addressLine1: "323 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.217218,
    longitude: -73.864973,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.217276820676695%2C-73.86475201025465&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=253.4&signature=w7q6Ou9DHEHHBo5_A6pe1BGTozQ=",
    tags: ["OFF_MARKET"],
    sqft: 3242,
    tenant: null,
    priorSale: {
      price: 470000,
      date: "2023-06-26",
    },
  },
  {
    id: "33",
    address: {
      addressLine1: "329 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.21741,
    longitude: -73.865036,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21749455058384%2C-73.8648379865592&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=242.0&signature=AcBfo2UHri-hhGdSEXRE5BiaS-0=",
    tags: ["OFF_MARKET"],
    sqft: 4686,
    tenant: null,
    priorSale: {
      price: 236000,
      date: "2019-03-27",
    },
  },
  {
    id: "34",
    address: {
      addressLine1: "331 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.217486,
    longitude: -73.865081,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21758443552537%2C-73.86487270110996&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=242.1&signature=Mku-Ofy-arb7ZRYK64tx_A4Z6RQ=",
    tags: ["OFF_MARKET"],
    sqft: 4970,
    tenant: null,
    priorSale: {
      price: 385000,
      date: "2019-02-21",
    },
  },
  {
    id: "35",
    address: {
      addressLine1: "335 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.21769,
    longitude: -73.865216,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21758332099634%2C-73.86487233149337&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=242.2&signature=n3W6paZQJ_1nh5mYtveQnqggSD8=",
    tags: ["FOR_LEASE"],
    sqft: 13125,
    tenant: { name: "Rate (Mortgage Lender)" },
    timeOnMarketDays: 60,
    priorSale: {
      price: 500000,
      date: "2018-09-13",
    },
  },
  {
    id: "36",
    address: {
      addressLine1: "373 Main Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.218767,
    longitude: -73.86557,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.2188158300755%2C-73.86535699797581&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=253.2&signature=lfWoHVmGIBrfu82S0FZvawMXqW8=",
    tags: ["OFF_MARKET"],
    sqft: 16002,
    tenant: { name: "Community Theater" },
    priorSale: {
      price: 812000,
      date: "2021-12-23",
    },
    withusValuation: {
      price: 1165000,
    },
  },
  {
    id: "37",
    address: {
      addressLine1: "391 Main Street / 150 Water Street",
      addressLine2: undefined,
      city: "Catskill",
      state: "NY",
      zip: "12414",
      countryCode: "US",
    },
    latitude: 42.219326,
    longitude: -73.866091,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.21944051320696%2C-73.86559491629897&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=253.9&signature=6_nlomliGZETGj6q0bdSNw1b8C0=",
    tags: ["OFF_MARKET"],
    sqft: 12615,
    tenant: { name: "MadeX Hudson and Left Bank Ciders" },
  },
  {
    id: "38",
    address: {
      addressLine1: "119 Main Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12565",
      countryCode: "US",
    },
    latitude: 42.24908,
    longitude: -73.6486,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.24922367128849%2C-73.64869396912833&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=162.7&signature=f8c4QCL_3DGioufqTGKxZKSTD0o=",
    tags: ["OFF_MARKET"],
    tenant: null,
  },
  {
    id: "39",
    address: {
      addressLine1: "14 Montgomery Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.25263,
    longitude: -73.79657,
    tags: ["OFF_MARKET"],
    tenant: null,
  },
  {
    id: "40",
    address: {
      addressLine1: "17 Montgomery Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.25194,
    longitude: -73.79601,
    tags: ["OFF_MARKET"],
    tenant: null,
  },
  {
    id: "41",
    address: {
      addressLine1: "35\u201337 Cross Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.25337,
    longitude: -73.79633,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.253382103094935%2C-73.79614047220979&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=225.0&signature=c44TYOId-u_JG_TFw_eIaQ1mfF4=",
    tags: ["OFF_MARKET"],
    tenant: null,
  },
  {
    id: "42",
    address: {
      addressLine1: "39\u201341 & 43\u201351 Cross Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.253183,
    longitude: -73.795871,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.253320935890635%2C-73.79605796574462&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=225.0&signature=-W-JtQtIyc6TGA5CNJo2cLuv0Uw=",
    tags: ["OFF_MARKET"],
    tenant: { name: "The Wick (Hotel)" },
  },
  {
    id: "43",
    address: {
      addressLine1: "60 South Front Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.254058,
    longitude: -73.797365,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.254101140950866%2C-73.79749596460869&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=108.7&signature=5JvZLa-ows33DtSxI_NXCMhHPqA=",
    tags: ["OFF_MARKET"],
    tenant: { name: "Mr. Cat Brasserie, Kitty's Market, Grapefruit Wines, The Caboose Hudson" },
  },
  {
    id: "44",
    address: {
      addressLine1: "72 South Front Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.2531,
    longitude: -73.79711,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.25467874057883%2C-73.79734781593855&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=105.0&signature=yIfoZKWydPL6gHDUr3qjsIQ2hTw=",
    tags: ["OFF_MARKET"],
    tenant: null,
  },
  {
    id: "45",
    address: {
      addressLine1: "8\u201312 Cross Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.253864,
    longitude: -73.796791,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.25306500622148%2C-73.79571275308537&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=45.0&signature=cPRUbJ-Yo-z2NXb3xvp4w2a8sp4=",
    tags: ["OFF_MARKET"],
    tenant: null,
  },
  {
    id: "46",
    address: {
      addressLine1: "31\u201333 Cross Street",
      addressLine2: undefined,
      city: "Hudson",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.253546,
    longitude: -73.796362,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.253576123993476%2C-73.79640218231638&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=225.0&signature=pYTai0Z8vXudA_J_6Lr6fqTZ7wY=",
    tags: ["OFF_MARKET"],
    tenant: null,
  },
  {
    id: "47",
    address: {
      addressLine1: "94 Main St",
      addressLine2: undefined,
      city: "Philmont",
      state: "NY",
      zip: "12565",
      countryCode: "US",
    },
    latitude: 42.248895,
    longitude: -73.650885,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.248700671694195%2C-73.65082871635711&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=345.9&signature=Uy6sGZDjuVXTObxa9L4T7oUI5wI=",
    tags: ["FOR_SALE"],
    sqft: 4800,
    tenant: { name: "High Falls Pizzeria & Taphouse" },
    timeOnMarketDays: 150,
    askingPrice: 725000,
    priorSale: {
      price: 2275000,
      date: "2005-10-24",
    },
  },
  {
    id: "48",
    address: {
      addressLine1: "95 Main St",
      addressLine2: undefined,
      city: "Philmont",
      state: "NY",
      zip: "12534",
      countryCode: "US",
    },
    latitude: 42.248771,
    longitude: -73.65032,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.24885635012543%2C-73.65032369056465&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=162.8&signature=nN8SfHaXqnJ0q9jDgc1tKFMFiYM=",
    tags: ["FOR_SALE"],
    sqft: 5800,
    tenant: { name: "Purpose Coworking" },
    timeOnMarketDays: 150,
    askingPrice: 535000,
    priorSale: {
      price: 2275000,
      date: "2005-10-24",
    },
  },
  {
    id: "49",
    address: {
      addressLine1: "100 Main St",
      addressLine2: undefined,
      city: "Philmont",
      state: "NY",
      zip: "12565",
      countryCode: "US",
    },
    latitude: 42.24892,
    longitude: -73.650539,
    imageUrl:
      "https://maps.googleapis.com/maps/api/streetview?size=640x640&location=42.248789073111894%2C-73.65055510847571&source=default&key=AIzaSyBA6-ZXAjs-LfnpHXdY0nGE84JZdNbznqE&heading=348.2&signature=9xnzaK0c5s9iyDWs4K6zIcysYmI=",
    tags: ["FOR_SALE"],
    sqft: 4400,
    tenant: { name: "McNan's Variety Foods, Landscape & Architectural Design" },
    timeOnMarketDays: 150,
    askingPrice: 525000,
    priorSale: {
      price: 2275000,
      date: "2005-10-24",
    },
  },
];
